import React from "react"

class ScenarioThemeValidatorComponent extends React.Component {

	render() {
		return (
			<div className="scenario-theme-validator">
				<div className="scenario-theme-validator-description">
					<span>Gestionnaire : </span>
					<span className="validator-admin">{this.props.theme.label}</span>
				</div>
				<div className="scenario-theme-validator-actions">
					<button className={`button is-primary`} onClick={this.props.onThemeValidToggle}>{(this.props.validator && this.props.validator.validated) ? "Invalider" : "Valider"} les valeurs</button>
				</div>
			</div>
		)
	}

}

export default ScenarioThemeValidatorComponent



// WEBPACK FOOTER //
// ./src/component/scenarii/admin/scenario-theme-validator-component.js